<template>
  <div class="container custom-side-filter">
    <transition name="van-fade">
      <div v-show="visible" class="mask" @click="close"></div>
    </transition>

    <transition name="van-slide-right">
      <div class="side wrap" v-show="visible">
        <div class="main">
          <van-cell
            title="校区"
            is-link
            :value-class="campusText ? 'selected' : ''"
            :value="campusText || '请选择'"
            @click="chooseCampus"
          />
          <van-cell
            title="课程"
            is-link
            :value-class="['van-ellipsis', params.curriculumName ? 'selected' : '']"
            :value="params.curriculumName || '请选择'"
            @click="choosePriceItem"
          />
          <van-cell
            title="班级"
            is-link
            :value-class="['van-ellipsis', params.className ? 'selected' : '']"
            :value="params.className || '请选择'"
            @click="chooseClass"
          />
          <van-cell
            v-if="config.showTeacher"
            title="老师"
            is-link
            :value-class="['van-ellipsis', teacherText ? 'selected' : '']"
            :value="teacherText || '请选择'"
            @click="chooseTeacher"
          />
          <van-cell
            v-if="config.showAssitants"
            title="助教"
            is-link
            :value-class="['van-ellipsis', assitantsText ? 'selected' : '']"
            :value="assitantsText || '请选择'"
            @click="chooseAssitants"
          />
          <van-cell
            title="教室"
            is-link
            :value-class="['van-ellipsis', classRoomText ? 'selected' : '']"
            :value="classRoomText || '请选择'"
            @click.stop="chooseClassroom"
          />
          <van-cell
            title="学员"
            is-link
            :value-class="['van-ellipsis', studentText ? 'selected' : '']"
            :value="studentText || '请选择'"
            @click="chooseStudent"
          />
          <div class="nav-wrapper">
            <div class="nav-title">已结班班级</div>
            <div class="nav-div">
              <div class="nav-box">
                <div
                  class="item-nav"
                  :class="{
                    active: params.classStatusList.includes(0),
                  }"
                  @click="changeClassStatus(0)"
                >
                  不展示
                </div>
              </div>
              <div class="nav-box">
                <div
                  class="item-nav"
                  :class="{
                    active: params.classStatusList.includes(1),
                  }"
                  @click="changeClassStatus(1)"
                >
                  展示
                </div>
              </div>
            </div>
          </div>
        </div>
        <van-row class="footer" gutter="12">
          <van-col span="12">
            <van-button block square round @click="reset"> 重置 </van-button>
          </van-col>
          <van-col span="12">
            <van-button block square round type="primary" @click="confirm"> 确定 </van-button>
          </van-col>
        </van-row>
      </div>
    </transition>
  </div>
</template>

<script>
let defaultParams = {
  classId: '',
  className: '',
  curriculumId: '',
  curriculumName: '',
  campusIds: [],
  campusList: [],
  studentIds: [],
  studentList: [],
  teacherIds: [],
  teacherList: [],
  assistantTeacherIds: [],
  assitantsList: [],
  classRoomIds: [],
  classRoomList: [],
  classStatusList: [0],
};

export default {
  name: '',
  components: {},
  data() {
    return {
      //   pageTitle: "选择校区",
      visible: false,
      params: JSON.parse(JSON.stringify(defaultParams)),
      config: {
        showTeacher: true,
        showMineOnly: false,
        showAssitants: false,
      },
    };
  },
  computed: {
    campusText: function () {
      let cps = this.params.campusList,
        text = '';
      if (cps.length == 1) {
        text = cps[0].name;
      } else if (cps.length > 1) {
        text = `${cps.length}个校区`;
      }
      return text;
    },
    teacherText: function () {
      let tcs = this.params.teacherList,
        text = '';
      if (tcs.length == 1) {
        text = tcs[0].name;
      } else if (tcs.length > 1) {
        text = `${tcs.length}个老师`;
      }
      return text;
    },
    assitantsText: function () {
      let tcs = this.params.assitantsList,
        text = '';
      if (tcs.length == 1) {
        text = tcs[0].name;
      } else if (tcs.length > 1) {
        text = `${tcs.length}个老师`;
      }
      return text;
    },
    studentText: function () {
      let tcs = this.params.studentList,
        text = '';
      if (tcs.length == 1) {
        text = tcs[0].name;
      } else if (tcs.length > 1) {
        text = `${tcs.length}个学员`;
      }
      return text;
    },
    classRoomText: function () {
      let cps = this.params.classRoomList,
        text = '';
      if (cps.length == 1) {
        text = cps[0].roomName;
      } else if (cps.length > 1) {
        text = `${cps.length}个教室`;
      }
      return text;
    },
  },
  methods: {
    changeClassStatus(status){
      if (this.params.classStatusList.includes(status)) {
        this.params.classStatusList = this.params.classStatusList.filter(item=>item!==status);
      } else {
        this.params.classStatusList.push(status);
      }
    },
    prevInit() {
      if (!this.$route.meta._resolve) {
        setTimeout(() => {
          this.$router.back();
        }, 0);
      } else {
        let opts = this.$route.meta.options || {};
        this._resolve = this.$route.meta._resolve;
        this._reject = this.$route.meta._reject;
        if (opts.params) {
          let params = JSON.parse(JSON.stringify(opts.params));
          this.params = Object.assign(this.params, params);
        }
        if (opts.config) {
          let config = JSON.parse(JSON.stringify(opts.config));
          this.config = Object.assign(this.config, config);
        }

        setTimeout(() => {
          this.visible = true;
        }, 0);
      }
    },
    // 选择校区
    async chooseCampus() {
      let res = await app.x3.side.xsCampus({
        ids: this.params.campusIds,
        list: this.params.campusList,
      });
      // 如果选中的校区发生变化，还需要清除已选的老师
      let oIdsStr = this.params.campusIds.join(),
        nOdsStr = res.ids.join();
      if (oIdsStr != nOdsStr) {
        this.params.campusIds = res.ids;
        this.params.campusList = res.list;
        this.switchCapumsClears();
      }
    },
    switchCapumsClears() {
      this.params.classId = '';
      this.params.className = '';
      // this.params.curriculumId = '';
      // this.params.curriculumName = '';
      this.params.studentIds = [];
      this.params.studentList = [];
      // this.params.teacherList = [];
      // this.params.teacherIds = [];
    },
    async choosePriceItem() {
      let res = await app.x3.side.xsCourse({
        id: this.params.curriculumId,
        config: {
          radio: true,
        },
      });
      if (res && res.curriculumId && this.params.curriculumId !== res.curriculumId) {
        this.params.classId = '';
        this.params.className = '';
      }
      this.params.curriculumId = res ? res.curriculumId : '';
      this.params.curriculumName = res ? res.curriculumName : '';
    },
    // 选择班级
    async chooseClass() {
      let res = await app.x3.side.xsClass({
        id: this.params.classId,
        params: {
          campusIds: this.params.campusIds,
          campusList: this.params.campusList,
          curriculumIds: this.params.curriculumId ? [this.params.curriculumId] : [],
          classStatus: '',
        },
        config: {
          radio: true,
          enableFilter: false,
        },
        filter: {
          enableCampusFilter: false,
        }
      });
      this.params.classId = res ? res.id : '';
      this.params.className = res ? res.className : '';
    },

    // 选择老师
    async chooseTeacher() {
      let res = await app.x3.side.xsTeacher({
        ids: this.params.teacherIds,
        list: this.params.teacherList,
      });

      this.params.teacherIds = res.ids;
      this.params.teacherList = res.list;
    },
    // 选择助教
    async chooseAssitants() {
      let res = await app.x3.side.xsTeacher({
        ids: this.params.assistantTeacherIds,
        list: this.params.assitantsList,
      });

      this.params.assistantTeacherIds = res.ids;
      this.params.assitantsList = res.list;
    },
    // 选择教室
    async chooseClassroom() {
      let res = await app.x3.side.xsClassroom({
        ids: this.params.classRoomIds,
        list: this.params.classRoomList,
        config: {},
        params: {
          campusIds: this.params.campusIds,
          campusList: this.params.campusList,
        },
      });
      this.params.classRoomIds = res.ids;
      this.params.classRoomList = res.list;
    },
    async chooseStudent() {
      let res = await app.x3.side.xsStudent({
        id: this.params.studentIds && this.params.studentIds[0],
        config: {
          enableLeft: false,
          enableCampus: false,
          enableSearch: true,
          searchIcon: false,
          enableFilter: false,
        },
        params: {
          campusIds: [...this.params.campusIds],
          status: [0, 1, 7],
        },
      });

      this.params.studentIds = res && res.id ? [res.id] : [];
      this.params.studentList = res ? [res] : [];
    },
    // 重置
    reset() {
      this.params = Object.assign(
        JSON.parse(JSON.stringify(defaultParams)),
        this.config.showMineOnly
          ? { teacherIds: [app.teacher.user.id], teacherList: [app.teacher.user] }
          : {}
      );
    },
    render() {},
    doneAnima() {
      this.$router.back();
      return new Promise(rsv => {
        setTimeout(() => {
          rsv();
        }, 100);
      });
    },
    async close() {
      await this.doneAnima();
    },
    async confirm() {
      await this.doneAnima();
      this._resolve(
        JSON.parse(
          JSON.stringify({
            params: this.params,
          })
        )
      );
    },
  },
  created() {
    this.prevInit();
    this.render();
  },
  beforeDestroy() {},
  watch: {
    '$vxRoute.vx_action': function (nv, ov) {
      // console.log(nv);
      if (nv == 'vx-out') {
        this.visible = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background: transparent;
  .mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 1;
  }
  .side {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: var(--x3-slide-left);
    background: var(--g1);
    z-index: 2;
  }
  .wrap {
    display: flex;
    flex-direction: column;
    font-size: var(--fs-md);
    color: var(--g8);
    background: var(--white);
    .main {
      flex: 1;
      overflow-y: auto;
      ::v-deep .van-cell__title {
        width: calc(var(--w) * 65);
        flex: unset;
        white-space: nowrap;
      }
      .nav-wrapper {
        margin-left: calc(var(--gap) * 16);
        .nav-title {
          padding: calc(var(--gap) * 14) calc(var(--gap) * 17) calc(var(--gap) * 8) 0;
          font-size: var(--fs-md);
          line-height: var(--lh-md);
          color: var(--g7);
        }
        .date-box {
          margin-right: calc(var(--gap) * 18);
          height: calc(var(--w) * 36);
          line-height: calc(var(--w) * 36);
          text-align: center;
          border-radius: var(--radius-base);
          border: 1px solid var(--g4);
          cursor: pointer;
        }
        .nav-div {
          display: flex;
          flex-wrap: wrap;
          margin: calc(var(--gap) * 8) calc(var(--gap) * 8) 0 0;
        }
        .nav-box {
          width: 33.33%;
          padding: calc(var(--gap) * 8);
          .item-nav {
            height: calc(var(--w) * 32);
            line-height: calc(var(--w) * 32);
            text-align: center;
            border-radius: var(--radius-md);
            background-color: var(--g1);
            white-space: nowrap;
            &.active,
            &.all {
              color: var(--c1);
              background-color: rgba(var(--c1-rgb), 0.08);
            }
          }
        }
      }
    }
  }
}
</style>